import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { FormFoldersStitchService, FormFolderStitchFilters } from '@modules/forms/services/form-folders.service';
import { FormsKpListStateService } from '@modules/forms/services/forms-kp-list-state.service';
import { type FormFolderStitch } from '@modules/forms/types/form-stitch';
import { type FormsKpListState } from '@modules/forms/types/forms-kp-list-state';
import { FORMS_KP_SECTION_IMPORTS } from '../forms-section/forms-section.component';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-form-folders-section',
  standalone: true,
  templateUrl: '../forms-section/forms-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: FORMS_KP_SECTION_IMPORTS,
  providers: FormsKpListStateService.providers(),
})
export class KnowledgeFormFoldersSectionComponent
  extends KnowledgeStitchSectionComponent<FormFolderStitch, FormFolderStitchFilters>
  implements OnInit
{
  protected readonly listStateService = inject(FormsKpListStateService, { self: true });
  protected readonly stitchService = inject(FormFoldersStitchService);
  protected readonly folder = true;

  public override ngOnInit(): void {
    this.state = new FormFolderStitchFilters({ withEmpty: true });
    super.ngOnInit();
  }
  public handleFilter(listState: FormsKpListState): void {
    this.filterChange.emit();
    this.filters = new FormFolderStitchFilters({
      displayTimeZone: this.displayTimeZoneService.timeZone(),
    }).applyListState(listState);
    this.updateFilters();
  }
}
